import type * as React from 'react';
import { get } from '@Domain/Api';
import subjectUsersFetched, {
	type SubjectUserPayload,
	type SubjectUsersFetchedAction,
} from '@Application/Subjects/Members/Actions/subjectUsersFetched';
import subjectUsersFetchFailed, {
	type SubjectUsersFetchFailedAction,
} from '@Application/Subjects/Members/Actions/subjectUsersFetchFailed';
import type FetchSubjectUsers from '@Application/Subjects/Members/Queries/FetchSubjectUsers';
import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = SubjectUsersFetchedAction | SubjectUsersFetchFailedAction;

export default (query: FetchSubjectUsers) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const users = await get<SubjectUserPayload[]>(
				`${buildSubjectApiPath(query.facilityId, query.subject)}/users`,
			);

			const action = subjectUsersFetched(query.subject.subjectId, users, query.subject.typeKey);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectUsersFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
